import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";

import styles from "./Index.module.scss";

const CompanyNameCheck = ({ data }) => {
  return (
    <div className="bg-bbc-gradient-9">
      <div className="container">
        <div className="row py-6 lg:py-0">
          <div className="col-12 mb-10 self-center lg:col-5 lg:mb-0">
            <Title
              text={data.title}
              as="h2"
              className="mb-6 pr-0 text-bbc-30px font-semibold capitalize text-bbc-main"
            />
            <p className="mb-6 text-base font-normal text-white">
              {data.description}
            </p>
            <div className="text-center lg:text-left">
              <LinkRouter
                href="/guide-and-tool/singapore-company-name-check"
                target="_blank"
                className="inline-block bg-bbc-brand-500 px-6 py-2 font-medium text-white"
                style={{ borderRadius: "50px" }}
              >
                Get Started
              </LinkRouter>
            </div>
          </div>
          <div className="col-12 relative my-0 text-center lg:col-7 lg:my-28 lg:text-left">
            <Img {...data.image} />
            <div
              className={`absolute hidden items-center justify-center rounded-lg bg-white px-10  py-4 ${styles.nation}`}
            >
              <Img
                className="mr-3"
                src="/assets/icons/nation.svg"
                alt="online baking tool"
              />
              <span className="text-sm font-medium text-bbc-brand-700">
                Nation
              </span>
            </div>
            <div
              className={`shadow-bbc absolute hidden items-center justify-center rounded-lg bg-white px-10 py-4 ${styles.emailAddress}`}
            >
              <Img
                className="mr-3"
                src="/assets/icons/mail-switch.svg"
                alt="online baking tool"
                width={22}
                height={24}
              />
              <span className="text-sm font-medium text-bbc-brand-700">
                Email Address
              </span>
            </div>
            <div
              className={`shadow-bbc absolute hidden items-center justify-center rounded-lg bg-white px-10 py-4 ${styles.entityName}`}
            >
              <Img
                className="mr-3"
                src="/assets/icons/user-switch.svg"
                alt="user-switch"
                width={22}
                height={24}
              />
              <span className="text-sm font-medium text-bbc-brand-700">
                Entity Name
              </span>
            </div>
            <div
              className={`shadow-bbc absolute hidden items-center justify-center rounded-lg bg-white px-10 py-4 ${styles.entityType}`}
            >
              <Img
                className="mr-3"
                src="/assets/icons/entity-type.svg"
                alt="user-switch"
                width={22}
                height={24}
              />
              <span className="text-sm font-medium text-bbc-brand-700">
                Entity Type
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyNameCheck;

CompanyNameCheck.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

CompanyNameCheck.defaultProps = {
  className: "",
};
